module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/core-js/library/modules/_library.js
 ** module id = 91
 ** module chunks = 0
 **/